import type { TenantUserSummary } from "./tenantUsers.types";

/**
 * Offline fixtures for the story-invite picker's user search, shaped exactly
 * like `GET /api/v2/tenants/:tenantId/users` so switching to the live
 * endpoint needs no call-site change.
 *
 * Scenarios (REACT_APP_TENANT_USERS_SCENARIO):
 *   default — five active tenant members, matched against `search` client-side
 *   empty   — no matches for any search term
 *   error   — the endpoint fails, to exercise the error surface
 */
export type TenantUsersScenario = "default" | "empty" | "error";

/** Real network is never instant; without this the loading states are invisible. */
export const MOCK_TENANT_USERS_LATENCY_MS = 300;

export const MOCK_TENANT_USERS: TenantUserSummary[] = [
  {
    user_id: "11111111-1111-4111-8111-000000000002",
    account_id: "33333333-3333-4333-8333-000000000001",
    email: "nancy.thomas@company.com",
    first_name: "Nancy",
    last_name: "Thomas",
    role_name: "member",
  },
  {
    user_id: "11111111-1111-4111-8111-000000000003",
    account_id: "33333333-3333-4333-8333-000000000002",
    email: "barry.allen@company.com",
    first_name: "Barry",
    last_name: "Allen",
    role_name: "member",
  },
  {
    user_id: "11111111-1111-4111-8111-000000000004",
    account_id: "33333333-3333-4333-8333-000000000003",
    email: "priya.shah@company.com",
    first_name: "Priya",
    last_name: "Shah",
    role_name: "tenant_admin",
  },
  {
    user_id: "11111111-1111-4111-8111-000000000005",
    account_id: "33333333-3333-4333-8333-000000000004",
    email: "diego.moreno@company.com",
    first_name: "Diego",
    last_name: "Moreno",
    role_name: "viewer",
  },
  {
    user_id: "11111111-1111-4111-8111-000000000006",
    account_id: "33333333-3333-4333-8333-000000000005",
    email: "wei.zhang@company.com",
    first_name: "Wei",
    last_name: "Zhang",
    role_name: "member",
  },
];

/** Same substring match the live endpoint documents: email/first name/last name. */
export const filterMockTenantUsers = (
  users: TenantUserSummary[],
  search: string | undefined,
): TenantUserSummary[] => {
  const term = search?.trim().toLowerCase();
  if (!term) return users;
  return users.filter((user) =>
    [user.email, user.first_name, user.last_name]
      .filter(Boolean)
      .some((field) => field!.toLowerCase().includes(term)),
  );
};
